import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { CreateWebFormInput, UpdateWebFormInput, WebFormResponse } from '@orion/contracts';
import { api } from '../../../lib/api-client.js';

const KEY = ['admin-web-forms'];

export function useWebFormsQuery() {
  return useQuery({ queryKey: KEY, queryFn: () => api.get<WebFormResponse[]>('/admin/web-forms') });
}

export function useCreateWebForm() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateWebFormInput) => api.post<WebFormResponse>('/admin/web-forms', input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: KEY }),
  });
}

export function useUpdateWebForm() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: UpdateWebFormInput }) =>
      api.patch<WebFormResponse>(`/admin/web-forms/${id}`, input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: KEY }),
  });
}

export function useRegenerateWebFormKey() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.post<WebFormResponse>(`/admin/web-forms/${id}/regenerate-key`),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: KEY }),
  });
}

export function useDeleteWebForm() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.delete<void>(`/admin/web-forms/${id}`),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: KEY }),
  });
}
